import React, { Component } from "react";
import { Tag } from "antd";
import F from "../Functions";

class AssociateUserTags extends Component {
  render() {
    const { associate_users } = this.props;

    const chundData = F.slicePoliciesIntoChunks(associate_users, 3, false);

    const firstChunkLsit = chundData.slice(0, 1);
    const nChunkList = chundData.slice(1, chundData.length);

    // F.log("chundData 2 =>" + JSON.stringify(firstChunkLsit));
    // F.log("chundData 3 =>" + JSON.stringify(nChunkList));

    return (
      <div>
        {firstChunkLsit.length > 0 &&
          firstChunkLsit[0].map((u, i) => {
            return (
              <Tag key={i}>
                <a
                  href={"/app#/customer/" + u.id}
                >{`${u.first_name} ${u.last_name}`}</a>
              </Tag>
            );
          })}

        {nChunkList.map(function(list, i) {
          return (
            <p key={i}>
              <div style={{ marginTop: 8 }}>
                {list.map(function(u, j) {
                  return (
                    <Tag key={j}>
                      <a
                        href={"/customer/" + u.id}
                      >{`${u.first_name} ${u.last_name}`}</a>
                    </Tag>
                  );
                })}
              </div>
            </p>
          );
        })}
      </div>
      // <div>
      //   {associate_users.map((userList, i) => {
      //     return (
      //       <Tag key={i}>
      //         <a
      //           href={"/customer/" + u.id}
      //         >{`${u.first_name} ${u.last_name}`}</a>
      //       </Tag>
      //     );
      //   })}
      // </div>
    );
  }
}

export default AssociateUserTags;



// WEBPACK FOOTER //
// ./src/components/associate-user-tags.js